import React from 'react';

import { isCreateOrAssignedOrder } from 'common/utilities/orderStatusUtils';
import {
  getContactNameJSX,
  getDeliveryDriver,
  getRaiderContactJSX,
  getRaiderMessageJSX,
} from '../sharedTemplates/orderSummaryRaiderDetailsTemplates';

const OrderSummaryRaiderDetailsView = props => {
  const { orderDetails } = props;
  const { isMobileView, showDeliveryDriverDetails } = orderDetails;

  return (
    <>
      {showDeliveryDriverDetails && (
        <div className='delivery-raider-info col-12'>
          <div className='row'>
            {getDeliveryDriver()}
            {!isMobileView && !isCreateOrAssignedOrder(orderDetails) && getContactNameJSX(orderDetails)}
          </div>
          <div className='row mt-10px'>
            {getRaiderMessageJSX(orderDetails)}
            {!isMobileView && !isCreateOrAssignedOrder(orderDetails) && getRaiderContactJSX(orderDetails)}
          </div>
          {isMobileView && !isCreateOrAssignedOrder(orderDetails) && (
            <div className='row mt-10px'>
              {getContactNameJSX(orderDetails)}
              {getRaiderContactJSX(orderDetails)}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default OrderSummaryRaiderDetailsView;
